var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_76",
    "data-name": "Group 76",
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.995,
    height: 40,
    viewBox: "0 0 39.995 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M187.733,260.666a.667.667,0,0,0,.666.666h2.667a.667.667,0,0,0,.666-.666v-4a.667.667,0,0,0-.666-.666H188.4a.667.667,0,0,0-.666.666v4Zm1.333-3.333H190.4V260h-1.333Z",
    transform: "translate(-173.067 -236.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M188.4,158.935h2.667a.667.667,0,0,0,.666-.666v-4a.667.667,0,0,0-.666-.666H188.4a.667.667,0,0,0-.666.666v4a.667.667,0,0,0,.666.667Zm.666-4H190.4V157.6h-1.333Z",
    transform: "translate(-173.068 -141.601)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M120.476,12.571l9.656-5.794,9.656,5.794a.667.667,0,1,0,.687-1.143L130.8,5.619V1.333h3.333V2.667h-2a.667.667,0,1,0,0,1.333H134.8a.667.667,0,0,0,.666-.666V.666A.667.667,0,0,0,134.8,0h-4.667a.667.667,0,0,0-.666.666V5.619l-9.676,5.806a.667.667,0,0,0,.687,1.143Z",
    transform: "translate(-110.133 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M54.533,261.335a.667.667,0,0,0,.666-.666v-4a.667.667,0,0,0-.666-.666H51.866a.667.667,0,0,0-.666.666V258a.667.667,0,0,0,1.333,0v-.666h1.333v3.333A.667.667,0,0,0,54.533,261.335Z",
    transform: "translate(-47.2 -236.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M137.867,199.2V179.866a.667.667,0,0,0-1.333,0V199.2a.667.667,0,1,0,1.333,0Z",
    transform: "translate(-125.868 -165.201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M103.066,367.735h22.666a.667.667,0,0,0,0-1.333h-6v-6.666h.666a.667.667,0,1,0,0-1.333h-12a.667.667,0,1,0,0,1.333h.666V366.4h-6a.667.667,0,1,0,0,1.333Zm12-4a.667.667,0,1,0,0-1.333v-2.667H118.4V366.4h-3.333Zm-4.666-4h3.333V362.4a.667.667,0,1,0,0,1.333V366.4H110.4Z",
    transform: "translate(-94.401 -330.402)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M412.934,366.933h-2.667a.667.667,0,0,0-.666.666v4a.667.667,0,0,0,.666.666h2.667a.667.667,0,0,0,.666-.666v-4a.667.667,0,0,0-.666-.664Zm-.666,4h-1.333v-2.667h1.333Z",
    transform: "translate(-377.602 -338.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M412.934,264.533h-2.667a.667.667,0,0,0-.666.666v4a.667.667,0,0,0,.666.666h2.667a.667.667,0,0,0,.666-.666v-4a.667.667,0,0,0-.666-.664Zm-.666,4h-1.333v-2.667h1.333Z",
    transform: "translate(-377.602 -243.866)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M96.933,494.933h-28a.667.667,0,0,0,0,1.333h28a.667.667,0,1,0,0-1.333Z",
    transform: "translate(-62.933 -456.266)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M401.2,187.733a.667.667,0,0,0-.666.666v.666H393.2a.667.667,0,1,0,0,1.333h7.333v22a.667.667,0,1,0,1.333,0v-24a.667.667,0,0,0-.663-.664Z",
    transform: "translate(-361.869 -173.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M273.067,260.666a.667.667,0,0,0,.666.666H276.4a.667.667,0,0,0,.666-.666v-4A.667.667,0,0,0,276.4,256h-2.667a.667.667,0,0,0-.666.666Zm1.333-3.333h1.333V260H274.4Z",
    transform: "translate(-251.734 -236.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M6.666,315.863c0-.087-.037-8.663-3.333-8.663S0,315.78,0,315.863a3.339,3.339,0,0,0,2.667,3.266v3.4a.667.667,0,1,0,1.333,0v-3.4a3.339,3.339,0,0,0,2.666-3.266Zm-3.333,2a2,2,0,0,1-2-2c0-3.321.892-7.333,2-7.333s2,4.012,2,7.333a2,2,0,0,1-2,2Z",
    transform: "translate(0 -283.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M359.734,191.334v-20a.667.667,0,0,0-1.333,0v20a.667.667,0,1,0,1.333,0Z",
    transform: "translate(-330.401 -157.334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M273.733,158.935H276.4a.667.667,0,0,0,.666-.666v-4a.667.667,0,0,0-.666-.666h-2.667a.667.667,0,0,0-.666.666v4a.667.667,0,0,0,.666.667Zm.666-4h1.333V157.6H274.4Z",
    transform: "translate(-251.734 -141.601)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M.666,196.4a.667.667,0,0,0,.666-.666V190.4H8.663a.667.667,0,1,0,0-1.333H1.333V188.4A.667.667,0,0,0,0,188.4v7.333a.667.667,0,0,0,.666.672Z",
    transform: "translate(0 -173.069)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampus);
export default __webpack_public_path__ + "static/media/campus.88a095b40b55c1d064908404dbe33f1e.svg";
export { ForwardRef as ReactComponent };